var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.571,
    height: 32,
    viewBox: "0 0 36.571 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M27.429,32H9.143c.00331-2.52312,2.04788-4.56769,4.571-4.571h2.286v-7.086c-2.87308-.58246-5.41084-2.25054-7.085-4.657-3.61619,1.13384-7.46685-.8785-8.60069-4.49469C.10645,10.52839.00047,9.83775,0,9.143v-4.572h6.857V0h22.857v4.571h6.857v4.572c-.00259,3.78978-3.07691,6.8599-6.86669,6.85731-.69475-.00047-1.38539-.10645-2.04832-.31431-1.67387,2.40676-4.21176,4.07493-7.085,4.657v7.086h2.286c2.52351.00275,4.5687,2.04749,4.572,4.571ZM15.024,3.937v2.991h1.676v8.891h3.333V3.937h-5.009ZM29.714,6.857v2.286c.00167,1.39229-.25185,2.77311-.748,4.074.24678.04523.49711.06832.748.069,2.2872-.0022,4.1408-1.8558,4.143-4.143v-2.286h-4.143ZM2.714,6.857v2.286c.00221,2.2872,1.8558,4.14079,4.143,4.143.25122-.00072.50188-.02381.749-.069-.49636-1.30087-.75022-2.68165-.749-4.074v-2.286H2.714Z",
    fill: "gold",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinTrophy);
export default __webpack_public_path__ + "static/media/win-trophy.1ba1b4098a6964259748dd7c3a7e7c10.svg";
export { ForwardRef as ReactComponent };